import {Header} from "semantic-ui-react";

export default function InviteHeader(props: {name: string}){

    return(
        <Header as='h1' color='black' textAlign='left'>
        Tach {props.name},
        </Header>
    )
}